<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

// **************** IMPORTANT: Turn on prerendering in Netlify for social media sharing cards ****************
const myDescription = 'The Universal Charter for National Park Cities';
const myTitle = 'The Universal Charter for National Park Cities'; // default title
const myTemplate = 'Universal Charter for National Park Cities';
const myUrl = 'https://www.nationalparkcity.org/charter';
const myImage = 'https://npc-universal-charter.netlify.com/static/images/social.jpg'; // generic
const myTwitterHandle = '@NatParkCityFdn';

export default {
  name: 'App',
  // Meta tags using Vue-Meta. Note will only be visible client side via:
  // 1. the browser INSPECT not VIEW SOURCE!!!
  // 2. if accessed by a bot via prerendering
  // Tags being used based on https://alligator.io/vuejs/vue-seo-tips/
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: myTitle,
    // all titles will be injected into this template
    titleTemplate: '%s | ' + myTemplate,
    meta: [
      {charset: 'utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: myDescription},

      // OpenGraph data (Most widely used)
      // On this item setting unique id vmid: so can be overridden by child components
      {vmid: 'og:title', property: 'og:title', content: `${myTitle} | ${myTemplate}`},
      {property: 'og:site_name', content: myTitle},
      // The list of types is available here: http://ogp.me/#types
      {property: 'og:type', content: 'website'},
      // Should the the same as your canonical link, see below.
      {vmid: 'og:url', property: 'og:url', content: myUrl},
      {vmid: 'og:image', property: 'og:image', content: myImage},
      // Often the same as your meta description, but not always.
      {vmid: 'og:description', property: 'og:description', content: myDescription},

      // Twitter card
      {name: 'twitter:card', content: 'summary_large_image'},
      {name: 'twitter:site', content: myTwitterHandle},
      {vmid: 'twitter:title', name: 'twitter:title', content: `${myTitle} | ${myTemplate}`},
      {vmid: 'twitter:description', name: 'twitter:description', content: myDescription},
      {name: 'twitter:creator', content: myTwitterHandle},
      {vmid: 'twitter:image', name: 'twitter:image', content: myImage},

      // Google / Schema.org markup:
      {itemprop: 'name', content: `${myTitle} | ${myTemplate}`},
      {itemprop: 'description', content: myDescription},
      {itemprop: 'image', content: myImage}
    ],
  }
}
</script>

<style>
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
}
</style>
<style lang="scss">
  @import '~bootstrap/scss/bootstrap.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue